import script from "./PunchList.vue?vue&type=script&lang=ts&setup=true"
export * from "./PunchList.vue?vue&type=script&lang=ts&setup=true"

import "./PunchList.vue?vue&type=style&index=0&id=e1fce7c4&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1fce7c4"]])

export default __exports__